import { SiteLinks } from "interfaces";
import { SaleTag } from "interfaces/web-store/sale-tag";
import { matchPath } from "react-router-dom";

interface Params {
	tag: SaleTag;
	pathname: string;
	linkTitle?: string;
	links: SiteLinks;
}

type SectionPolicy = {
	showGlobally?: boolean;
	hideOnHome?: boolean;
	hiddenOnRoutes?: string[];
};

export const isStickyTagVisibleOnRoute = ({
	tag,
	pathname,
	linkTitle,
	links
}: Params): boolean => {
	const section = tag.megaMenuTagSection;
	const sections = {
		eliteDeals: links.elite_deals.title,
		friendCenter: links.friend_center.title
	};

	const sectionPolicies: Record<string, SectionPolicy> = {
		[sections.eliteDeals]: {
			showGlobally: true,
			hideOnHome: true,
			hiddenOnRoutes: [links.elite_deals.path]
		},
		[sections.friendCenter]: {
			showGlobally: true,
			hideOnHome: true
		}
	};

	const policy = sectionPolicies[section];
	const isHomeRoute = pathname === links.home.path;
	const isHiddenByRoute =
		policy?.hiddenOnRoutes?.some((routePath) =>
			matchPath({ path: routePath, end: false }, pathname)
		) ?? false;

	if (section === linkTitle && !isHiddenByRoute) {
		return true;
	}

	if (!policy?.showGlobally) {
		return false;
	}

	if (policy.hideOnHome && isHomeRoute) {
		return false;
	}

	if (isHiddenByRoute) {
		return false;
	}

	return true;
};
